module.exports = __webpack_public_path__ + "img/tab-placeholder-vertical.e1d8d835.svg";